const queryKeys = {
  all: () => ['email-analysis'] as const,

  details: () => [...queryKeys.all(), 'detail'] as const,

  byMessageId: (id: string) => [...queryKeys.details(), id] as const,
};

export default queryKeys;
